import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getGridQuantities, getSelectedLensCartRecap } from '../../common/bulkOrder'

const useBulkOrderGridDerived = ({
  selectedLensId,
  lensGridAxis,
  diameter,
  side,
  cylinderSign,
}) => {
  const cartLines = useSelector(state => state.bulkOrder.cart.lines)

  const quantities = useMemo(
    () =>
      getGridQuantities({
        selectedLensId,
        lines: cartLines,
        diameter,
        side,
        cylinderSign,
        lensGridAxis,
      }),
    [selectedLensId, cartLines, diameter, side, cylinderSign, lensGridAxis],
  )
  const recap = useMemo(
    () => getSelectedLensCartRecap({ selectedLensId, lines: cartLines }),
    [selectedLensId, cartLines],
  )

  return { quantities, recap }
}

export default useBulkOrderGridDerived
